import { render, staticRenderFns } from "./CardBtnGroup.vue?vue&type=template&id=0a482ef7&"
import script from "./CardBtnGroup.vue?vue&type=script&lang=js&"
export * from "./CardBtnGroup.vue?vue&type=script&lang=js&"
import style0 from "./CardBtnGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports